module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-31-min.979f33f2.jpg";